import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SeoHead from './SeoHead';
import { DEFAULT_SEO } from '../lib/seo';

const ServerErrorPage: React.FC = () => {
  const location = useLocation();

  return (
    <div className='bg-watercolor-gradient min-h-screen'>
      <SeoHead
        noIndex
        override={{
          ...DEFAULT_SEO,
          title: '500: Server error | Layerre',
          url: `https://layerre.com${location.pathname}`,
        }}
      />
      <header className='border-b border-gray-200 bg-white/80 backdrop-blur-sm'>
        <div className='w-full px-4 sm:px-6 lg:px-8'>
          <div className='flex items-center justify-between h-16 max-w-6xl mx-auto'>
            <div className='flex-shrink-0'>
              <Link to='/' className='flex items-center gap-3'>
                <img
                  src='/layerre-logo.svg'
                  alt='Layerre Logo'
                  className='h-8 w-auto'
                />
              </Link>
            </div>
            <nav className='flex items-center gap-4 sm:gap-6'>
              <Link
                to='/pricing/'
                className='font-sans text-sm sm:text-base text-slate-700 hover:text-primary-600 transition-colors'
              >
                Pricing
              </Link>
              <Link
                to='/blog/'
                className='font-sans text-sm sm:text-base text-slate-700 hover:text-primary-600 transition-colors'
              >
                Blog
              </Link>
              <Link
                to='/docs/'
                className='font-sans text-sm sm:text-base text-slate-700 hover:text-primary-600 transition-colors'
              >
                Docs
              </Link>
            </nav>
          </div>
        </div>
      </header>

      <main className='max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20'>
        <div className='max-w-2xl'>
          <p className='font-header text-sm font-semibold tracking-wide text-primary-700/90 mb-3'>
            500
          </p>
          <h1 className='font-header text-4xl sm:text-5xl font-bold text-slate-900 mb-5 leading-tight'>
            Something went wrong
          </h1>
          <p className='font-sans text-lg text-slate-600 leading-relaxed mb-8'>
            We hit an unexpected error loading{' '}
            <span className='font-mono text-slate-700'>
              {location.pathname}
            </span>
            . Try again, or head back to a working page.
          </p>

          <div className='flex flex-wrap gap-3'>
            <button
              type='button'
              onClick={() => window.location.reload()}
              className='inline-flex items-center rounded-lg bg-primary-600 px-4 py-2.5 font-sans text-sm font-semibold text-white shadow-sm hover:bg-primary-700 transition-colors'
            >
              Reload page
            </button>
            <Link
              to='/'
              className='inline-flex items-center rounded-lg bg-white px-4 py-2.5 font-sans text-sm font-semibold text-slate-900 shadow-sm ring-1 ring-inset ring-gray-200 hover:bg-slate-50 transition-colors'
            >
              Go to homepage
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ServerErrorPage;
